import { isObjectDeeplyChanged } from '../../util/state';
import { State } from '../App/selector';

/**
 * Update flags for TariffSelection container
 */
export const getUpdateFlags = (newState: State, oldState: State) => {
    const { availableTariffs, selectedTariffId, isAvailabilityChecked, isContentEnabled, providerType, isFriendsAndFamily } = newState;
    const hasAvailableTariffsChanged = availableTariffs && isObjectDeeplyChanged(availableTariffs, oldState.availableTariffs);
    const hasSelectedChanged = selectedTariffId !== oldState.selectedTariffId;
    const hasAvailabilityChanged = isAvailabilityChecked !== oldState.isAvailabilityChecked;
    const isContentEnabledChanged = isContentEnabled !== oldState.isContentEnabled;

    return {
        tariffPicker: hasAvailableTariffsChanged || hasSelectedChanged || hasAvailabilityChanged,
        tariffBenefits: hasAvailableTariffsChanged || hasSelectedChanged || hasAvailabilityChanged,
        tariffLinks: hasAvailableTariffsChanged || hasSelectedChanged,
        content: isContentEnabledChanged || hasAvailabilityChanged,
        provider: oldState.providerType !== providerType,
        friendsAndFamily: isFriendsAndFamily !== oldState.isFriendsAndFamily,
    };
};
